'use strict';

function ProportionalProgressRing() {
  this.extends = [_ComponentDataBind, _ResponsiveLayout];
  this.declaredClass = null;
  this.node = null;
  this.$node = null;
  this.id = null;

  // Percent of dial filled by primary ring
  this.percent = null;

  // percent of the dial to be left as a gap between the 2 rings
  this.ringGapPercent = 5;

  // min/max percent that allows some fo the ring to be displayed
  this.minPercent = 12;
  this.maxPercent = 88;

  // get min and max positions for stroke length used to fill the rings
  this._strokeRange = {
    min: 338,
    max: 630
  };

  this._classes = {
    class: 'proportional-progress-ring',
    mod_show: 'proportional-progress-ring--show',
    dial: 'proportional-progress-ring__dial',
    default_wrapper: 'proportional-progress-ring__default-wrapper',
    primary_wrapper: 'proportional-progress-ring__primary-wrapper',
    default_ring: 'proportional-progress-ring__default-ring',
    primary_ring: 'proportional-progress-ring__primary-ring',
    background_orbs: 'proportional-progress-ring__orb-background'
  };

  this.init = function () {
    this._super();
    this.$node = $(this.node);
    this.$node.addClass(this._classes.class);
    this.$node.attr('role', 'progressbar');
    this.$node.attr('aria-valuemin', 0);
    this.$node.attr('aria-valuemax', 100);

    if (this.percent < this.minPercent) this.percent = this.minPercent;
    if (this.percent > this.maxPercent) this.percent = this.maxPercent;

    // Format SVG Dials
    this._$dial = $('' + ('<div>' + '<svg viewBox="0 0 100 100" class="') + this._classes.primary_wrapper + '" >' + '<g transform="translate(3.61, 3.61)">' + ('<circle class="' + this._classes.primary_ring + '"  cx="46.39" cy="46.39" r="46.39"/>') + '</g>' + '</svg>' + ('<svg viewBox="0 0 100 100" class="' + this._classes.default_wrapper + '" >') + '<g transform="translate(3.61, 3.61)">' + ('<circle class="' + this._classes.default_ring + '"  cx="46.39" cy="46.39" r="46.39"/>') + '</g>' + '</svg>' + '</div>');

    // Add SVG to component
    this.$node.append(this._$dial);
    this._$dial.addClass(this._classes.dial);

    // Add background orbs to dial
    this._$backgroundOrbs = $('<div></div>');
    this._$backgroundOrbs.addClass(this._classes.background_orbs);
    this.$node.append(this._$backgroundOrbs);

    // cache dom elements for rotaion changes
    this._$primaryWrapper = this.$node.find('.' + this._classes.primary_wrapper);
    this._$defaultWrapper = this.$node.find('.' + this._classes.default_wrapper);
    this._$primaryring = this.$node.find('.' + this._classes.primary_ring);
    this._$defaultring = this.$node.find('.' + this._classes.default_ring);

    // run updateDial to set initial position
    this.updateDial();

    // binding model updates to percent to update dial also
    this.onDataBindUpdate('percent', this.updateDial.bind(this));

    // bind window resize to update layout
    this.registerResponsiveFunction(this.updateLayout.bind(this), null, null);

    // Display and Height match the dial
    // this.$node.css({ opacity: 0.1 });
    this.$node.addClass(this._classes.mod_show);
    this.updateLayout();
  };

  this.initAllReady = function () {
    this._super();
    this.updateLayout();
  };

  this.destroy = function () {
    this._super();
  };

  this.updateLayout = function () {
    this.$node.height(this.$node.width());
  };

  this.updateDial = function () {
    this.$node.attr('aria-valuenow', this.percent);

    var computedLowerPercent = this.percent - this.ringGapPercent / 2;
    var computedHigherPercent = this.percent + this.ringGapPercent / 2;

    // Calculate Rotation of rings to align them correctly
    var primaryRotation = computedLowerPercent * 3.6 / 2;
    var defaultRotation = computedHigherPercent * 3.6 / 2;

    // Calculate length of stroke dash to fill the ring
    var primaryStrokeValue = this._strokeRange.min + (this._strokeRange.max - this._strokeRange.min) / 100 * computedLowerPercent;
    var defaultStrokeValue = this._strokeRange.min + (this._strokeRange.max - this._strokeRange.min) / 100 * (100 - computedHigherPercent);

    // Apply rotation and stroke dash length
    this._$primaryWrapper.css({ transform: 'rotate(' + (180 + primaryRotation) + 'deg)' });
    this._$defaultWrapper.css({ transform: 'rotate(' + (180 - defaultRotation) + 'deg)' });
    this._$primaryring.css({ 'stroke-dashoffset': primaryStrokeValue });
    this._$defaultring.css({ 'stroke-dashoffset': defaultStrokeValue });
  };

  this.setPercent = function (percent) {
    this.percent = percent;
    if (this.percent < this.minPercent) this.percent = this.minPercent;
    if (this.percent > this.maxPercent) this.percent = this.maxPercent;

    this.updateDial();
  };
}